import { render, staticRenderFns } from "./ImageSwiperSelector.vue?vue&type=template&id=94bf5936&scoped=true&"
import script from "./ImageSwiperSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSwiperSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageSwiperSelector.vue?vue&type=style&index=0&id=94bf5936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf5936",
  null
  
)

export default component.exports